/* unplugin-vue-components disabled */import { render } from "./DialogStage.vue?vue&type=template&id=45740a24"
import script from "./DialogStage.vue?vue&type=script&lang=js"
export * from "./DialogStage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__